<template>
  <div class="practice-dialog" @mousewheel="mousewheel" v-if="dialogShow">
    <div class="dialog-inner">
      <img
        class="close-img"
        src="../../assets/img/icon/close.png"
        alt=""
        @click="closeDialog"
      />
      <div class="dia-title">{{ info.name }}</div>
      <div class="dia-item">总题数：{{ info.subjectCount }}</div>
      <div class="dia-item col">已练习：{{ info.finishCount }}</div>
      <div class="dia-btns">
        <div class="btn" @click="closeDialog">取消</div>
        <div class="btn btn2" @click="handleSubmit">开始练习</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogShow: false,
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    openDialog() {
      this.dialogShow = true;
    },
    closeDialog() {
      this.dialogShow = false;
    },
    handleSubmit() {
      this.dialogShow = false;
      this.$emit("submit");
    },
    mousewheel(e) {
      e.preventDefault();
    },
  },
};
</script>
<style lang="less" scoped>
.practice-dialog {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 22;
  background-color: rgba(0, 0, 0, 0.6);
  .dialog-inner {
    position: relative;
    padding-right: 32px;
    width: 480px;
    height: 292px;
    border-radius: 8px;
    opacity: 1;
    background: #fff;
    box-sizing: border-box;
    .close-img {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    .dia-title {
      margin-bottom: 16px;
      padding-top: 32px;
      padding-left: 32px;
      font-weight: bold;
      font-size: 18px;
      line-height: 26px;
      color: #333333;
    }
    .dia-item {
      margin-bottom: 10px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    .dia-item.col {
      color: #3480ff;
    }
    .dia-btns {
      display: flex;
      align-items: center;
      justify-content: right;
      .btn {
        margin-right: 8px;
        width: 88px;
        height: 32px;
        border-radius: 16px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f2f2f2;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
      }
      .btn:hover {
        opacity: 0.8;
      }
      .btn1 {
        border: 1px solid #00b861;
        background: #fff;
        color: #00b861;
      }
      .btn2 {
        background-color: #00b861;
        color: #fff;
      }
    }
  }
}
</style>
